export default __webpack_public_path__ + "static/media/7-color.85d3ce99.svg";